import React, { useState, useEffect } from "react";

import withErrorHandling from "../HOC/ErrorHandling";
import { useSharedProps } from "../HOC/SharedProps";

import { Box, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";

import t from "../helpers/en";
import { getk8sLogs } from "../helpers/utils";
import {
  darkSurface,
  heroText,
  pageBackground,
  motionVariants,
} from "../helpers/designSystem";

import Table from "../components/Table/Table";

const rowsDetails = (data, totalElements) => ({
  header: [t.name, t.type, t.operation, t.createdBy, t.createdOn],
  body: data?.content,
  bodyCount: data?.content,
  totalElementsForPagination: data?.totalElements,
  bodyParams: (val) => [
    { value: val?.displayName },
    { value: val?.objectType },
    { value: val?.operationType },
    {
      value: val?.createdBy?.familyName
        ? `${val?.createdBy?.familyName} ${val?.createdBy?.givenName}`
        : val?.createdBy?.username,
    },
    { value: new Date(val?.createdOn).toLocaleString("en-US") },
  ],
});

const Logs = (props) => {
  const { showError } = props;

  const [data, setData] = useState({ content: [] });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(true);

  const { currentGroup } = useSharedProps();

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const fetchData = (pageNumber, pageSize, cb, onError) => {
    getk8sLogs({ pageNumber, pageSize }, (result, err) => {
      if (result) {
        setData({ ...result });
        cb && cb(result);
      } else {
        onError(err);
      }
    });
  };

  useEffect(() => {
    const callback = (cb) => {
      fetchData(page, rowsPerPage, cb, showError);
    };

    setIsLoading(true);
    callback(() => setIsLoading(false));
  }, [page, rowsPerPage, showError, currentGroup]);

  const onChangeRowsPerPage = (evt) => {
    setRowsPerPage(parseInt(evt.target.value, 10));
    setPage(0);
  };

  const onChangePage = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Box sx={{ ...pageBackground(isDarkMode), p: { xs: 2, md: 4 } }}>
      <motion.div {...motionVariants.heroEnter}>
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h3"
            sx={{ ...heroText(isDarkMode), mb: 1 }}
          >
            Events
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: isDarkMode ? darkSurface.textMuted : "rgba(15,23,42,0.65)" }}
          >
            Recent platform activity across your apps.
          </Typography>
        </Box>
      </motion.div>
      <Table
        rows={{
          ...rowsDetails(data),
        }}
        selectedRow={() => false}
        {...{
          page,
          rowsPerPage,
          onChangePage,
          onChangeRowsPerPage,
          isLoading,
        }}
      />
    </Box>
  );
};

export default withErrorHandling(Logs);
